import { z } from "zod";

export const LoginSchema = z.object({
  email: z.email(),
  password: z.string().min(1),
});

export const UserSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    email: z.email(),
    permission: z.array(z.string()).optional(),
    permissions: z.array(z.string()).default([]),
  })
  .transform(({ permission, permissions, ...user }) => ({
    ...user,
    permissions: permissions.length > 0 ? permissions : (permission ?? []),
  }));

export const LoginResponseSchema = z.object({
  user: UserSchema,
});

export type LoginRequest = z.infer<typeof LoginSchema>;
export type AuthUser = z.infer<typeof UserSchema>;
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
